/** Mulberry32 with explicit state so ?seed= is replayable. */
export class Rng {
  state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  next(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  int(min: number, max: number): number {
    return min + Math.floor(this.next() * (max - min + 1));
  }

  pick<T>(list: readonly T[]): T {
    return list[this.int(0, list.length - 1)]!;
  }

  chance(p: number): boolean {
    return this.next() < p;
  }

  float(min: number, max: number): number {
    return min + this.next() * (max - min);
  }
}

export function hashSeed(text: string): number {
  let h = 2166136261;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function readSeedFromUrl(search = window.location.search): string {
  const raw = new URLSearchParams(search).get("seed");
  if (raw && raw.trim()) return raw.trim().slice(0, 32);
  return "drippond";
}

export function uidFromRng(rng: Rng): string {
  return `m${(rng.next() * 0xffffffff) >>> 0}${((rng.next() * 0xffff) >>> 0).toString(16)}`;
}
